import React, { useEffect, useMemo, useState } from "react";
import axios from "../../../utills/api";
import { Row, Col, Card, CardBody, CardHeader } from "reactstrap";
import TableContainer from "../../../Components/Common/TableContainer";
import { toast } from "react-toastify";

const BestSellingProductsTable = () => {
  const [bestSelling, setBestSelling] = useState([]);

  const API_ENDPOINTS = {
    Food: "/food/order",
    Spa: "/spa",
    Wellness: "/wellness",
    Taxi: "/taxi-booking",
  };

  useEffect(() => {
  const fetchBestSelling = async () => {
    try {
      const [foodRes, spaRes, wellnessRes, taxiRes] = await Promise.all([
        axios.get(API_ENDPOINTS.Food),
        axios.get(API_ENDPOINTS.Spa),
        axios.get(API_ENDPOINTS.Wellness),
        axios.get(API_ENDPOINTS.Taxi),
      ]);

      const foodData = Array.isArray(foodRes.data)
        ? foodRes.data
        : Array.isArray(foodRes)
        ? foodRes
        : [];

      const spaData = Array.isArray(spaRes.data)
        ? spaRes.data
        : Array.isArray(spaRes)
        ? spaRes
        : [];

      const wellnessData = Array.isArray(wellnessRes.data)
        ? wellnessRes.data
        : Array.isArray(wellnessRes)
        ? wellnessRes
        : [];

      const taxiData = Array.isArray(taxiRes.data)
        ? taxiRes.data
        : Array.isArray(taxiRes)
        ? taxiRes
        : [];

      console.log("✅ Extracted Data:", {
        foodData,
        spaData,
        wellnessData,
        taxiData,
      });

      // Flatten food items
      let foodItems = [];
      foodData.forEach(order => {
        if (Array.isArray(order.items)) {
          order.items.forEach(item => {
            foodItems.push({
              name: item.name,
              price: item.price,
              quantity: item.quantity,
              type: "Food",
            });
          });
        }
      });

      const spaItems = spaData.map(item => ({
        name: item.treatmentName,
        price: item.price,
        quantity: 1,
        type: "Spa",
      }));

      const wellnessItems = wellnessData.map(item => ({
        name: item.activityName,
        price: item.price || 0,
        quantity: 1,
        type: "Wellness",
      }));

      const taxiItems = taxiData.map(item => ({
        name: item.name,
        price: item.fare || 0,
        quantity: 1,
        type: "Taxi",
      }));

      // Combine and aggregate
      const allItems = [...foodItems, ...spaItems, ...wellnessItems, ...taxiItems];

      const aggregateAll = arr => {
        const map = {};
        arr.forEach(item => {
          if (!item.name) return;
          if (map[item.name]) {
            map[item.name].orders += item.quantity;
            map[item.name].amount += item.price * item.quantity;
          } else {
            map[item.name] = {
              label: item.name,
              type: item.type,
              price: item.price,
              orders: item.quantity,
              amount: item.price * item.quantity,
            };
          }
        });
        return Object.values(map)
          .sort((a, b) => b.orders - a.orders)
          .slice(0, 10); // top 10 overall
      };

      const combined = aggregateAll(allItems);
      setBestSelling(combined);
    } catch (err) {
      console.error("❌ Error fetching best-selling data:", err);
      toast.error("Failed to fetch best-selling products.");
      setBestSelling([]);
    }
  };

  fetchBestSelling();
}, []);


  // Render badge for Type
  const renderTypeBadge = (type) => {
    switch (type) {
      case "Food":
        return <span className="badge text-uppercase bg-success-subtle text-success">{type}</span>;
      case "Spa":
        return <span className="badge text-uppercase bg-primary-subtle text-primary">{type}</span>;
      case "Wellness":
        return <span className="badge text-uppercase bg-warning-subtle text-warning">{type}</span>;
      case "Taxi":
        return <span className="badge text-uppercase bg-secondary-subtle text-secondary">{type}</span>;
      default:
        return <span className="badge text-uppercase bg-light text-dark">{type}</span>;
    }
  };

  const columns = useMemo(
    () => [
      { header: "Product/Service", accessorKey: "label", enableColumnFilter: false },
      {
        header: "Type",
        accessorKey: "type",
        enableColumnFilter: false,
        cell: ({ getValue }) => renderTypeBadge(getValue())
      },
      {
        header: "Price",
        accessorKey: "price",
        enableColumnFilter: false,
        cell: ({ getValue }) => `₹${getValue()}`
      },
      { header: "Orders", accessorKey: "orders", enableColumnFilter: false },
      {
        header: "Total Revenue",
        accessorKey: "amount",
        enableColumnFilter: false,
        cell: ({ getValue }) => `₹${getValue()}`
      },
    ],
    []
  );

  return (
    <React.Fragment>
      
        <Col xl={6} md={6}>
          <Card style={{height:"430px"}}>
            <CardHeader>
                 <h4 className="card-title mb-0 flex-grow-1">Top Selling Product/Services</h4>
            </CardHeader>
            <CardBody>
              <TableContainer
                columns={columns}
                data={bestSelling}
                customPageSize={5}
                isPagination
                className="text-nowrap"
                theadClass="bg-light" // light grey header
              />
            </CardBody>
          </Card>
        </Col>
    
    </React.Fragment>
  );
};

export default BestSellingProductsTable;

